import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import Button from "../../../ui/molecules/button"
import { SelectCustom } from "../../../ui/molecules/select"
import { ProdIntegrataNotScopo, ProdIntegrataNotType, regioniList, yes_no } from "../../../utils"
import Input from "../../../ui/molecules/input"
import { Calendar } from "../../../ui/molecules/calendar"
import { CohesionType } from "./dataService/dto"
import CheckboxGroup from "../../../ui/molecules/CheckBoxGroup"
import { useEffect, useState } from "react"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../ui/molecules/textArea"
import { CreateNotSQNPI, setCreationAdhesionDate, setCreationAdhesionType, setCreationCampaignYear, setCreationConfirmId, setCreationCustomerNotification, setCreationNote, setCreationNumber, setCreationProtocol, setCreationProtocolDate, setCreationProtocolId, setCreationPurpose, setCreationRegion, setCreationRegionalMark, setCreationRettificationId, setCreationType } from "./dataService/slice"
import { format } from "date-fns"

interface Props {
    close: () => void
}

export function NotifyAddProdIntegrata(props: Props) {
    const dispatch = useAppDispatch()
    const notificationState = useAppSelector(state => state.notification)
    const notificationSQNPIState = useAppSelector(state => state.NotificationSQNPI)
    const sessionState = useAppSelector(state => state.session)
    const navigate = useNavigate()
    const [selectedTypes, setSelectedTypes] = useState<CohesionType[]>([]);
    const handleTypesChange = (value: CohesionType) => {
        const currentTypes = [...selectedTypes];
        if (currentTypes.includes(value)) {
        }
        else {
            currentTypes.push(value)
            setSelectedTypes(currentTypes)
            dispatch(setCreationAdhesionType(currentTypes))
        }
    }
    useEffect(() => {
        dispatch(setCreationCustomerNotification(sessionState.selected.customerId))
    }, [])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>


                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Tipologia"
                            placeholder='Seleziona tipologia...'
                            value={notificationSQNPIState.createNotSQNPI.type}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setCreationType(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Anno Campagna'}
                            placeholder="Anno Campagna"
                            value={notificationSQNPIState.createNotSQNPI.campaignYear}
                            onChangeText={(text) => dispatch(setCreationCampaignYear(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Regione"
                            placeholder='Regione'
                            value={notificationSQNPIState.createNotSQNPI.region}
                            options={regioniList}
                            onChange={(value) => dispatch(setCreationRegion(value))}
                        />
                    </div>
                </div>
                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Numero'}
                            placeholder="Numero"
                            value={notificationSQNPIState.createNotSQNPI.number}
                            onChangeText={(text) => dispatch(setCreationNumber(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Protocollo'}
                            placeholder="Protocollo"
                            value={notificationSQNPIState.createNotSQNPI.protocol}
                            onChangeText={(text) => dispatch(setCreationProtocol(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Calendar
                            label="Data Protocollo"
                            selected={notificationSQNPIState.createNotSQNPI.protocolDate}
                            onChange={(date) => dispatch(setCreationProtocolDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>

                </div>
                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <Calendar
                            label="Data Adesione"
                            selected={notificationSQNPIState.createNotSQNPI.adhesionDate}
                            onChange={(date) => dispatch(setCreationAdhesionDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Scopo"
                            placeholder='Scopo'
                            value={notificationSQNPIState.createNotSQNPI.purpose}
                            options={ProdIntegrataNotScopo}
                            onChange={(value) => dispatch(setCreationPurpose(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Marchio Regionale"
                            placeholder='Scegli'
                            options={yes_no}
                            value={
                                notificationSQNPIState.createNotSQNPI.regionalMark ? 'Si' : 'No'
                            }
                            onChange={(value) => dispatch(setCreationRegionalMark(value))}
                        />
                    </div>
                </div>

                <div>
                    <div className='text-left mt-4'>
                        <div className="mb-3">
                            <span>Tipologia Adesione</span>
                        </div>
                        <div style={{ flex: '1', justifySelf: 'flex-start' }}>
                            <CheckboxGroup
                                name="tipo_adesione"
                                options={Object.values(CohesionType)}
                                selectedValues={selectedTypes}
                                onChange={handleTypesChange}
                                inline={true}
                                optionLabels={{
                                    [CohesionType.TERRENI]: "Terreno",
                                    [CohesionType.TRASFORMAZIONE_CONFEZIONAMENTO]: "Trasformazione / Confezionamento",
                                    [CohesionType.INTERMEDIAZIONE]: "Intermediazione",
                                    [CohesionType.COMMERCIALIZZAZIONE_PRODOTTO_SFUSO]: "Commercializzazione Prodotto Sfuso"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="pb-2 mt-4" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Conferma Domanda"
                            placeholder='Conferma Domanda'
                            value={notificationSQNPIState.createNotSQNPI.sqnpiNotificationConfirmationId}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setCreationConfirmId(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Rettifica Domanda"
                            placeholder='Rettifica Domanda'
                            value={notificationSQNPIState.createNotSQNPI.sqnpiNotificationRectificationId}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setCreationRettificationId(value))}
                        />
                    </div>
                </div>

                <div className="pb-2 mt-4" >
                    <div>
                        <ProtocolSearch
                            type="entry"
                            value={notificationSQNPIState.createNotSQNPI.requestProtocolId}
                            onSelect={(value) => dispatch(setCreationProtocolId(value))}
                        />
                    </div>
                </div>

                <div className="pb-2 mt-4" >
                    <div>
                        <TextArea
                            value={notificationSQNPIState.createNotSQNPI.note}
                            onChangeText={(text) => {
                                dispatch(setCreationNote(text))
                            }} />
                    </div>
                </div>

            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        // dispatch(resetMemberCreationRequest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(CreateNotSQNPI(notificationSQNPIState.createNotSQNPI))
                        }}
                    />
                </div>
            </div>
        </div>
    )
}